import Ws from "@/common/websocket.js";
export default {
    domain: 'https://www.weiqi888.com:5707',
    //domain: 'https://localhost:5707',
    version: '1.4.6',
    configJson: 'config.json', //跟工程名称id相同
    userInfo: null,
    levelConfig: null,
    playSound: true,
    pay: false,
    ws: null,
    rev_color: 0,
    school_name: '',
    chess_board_size: 750,
    class_list: [],
    sysInfo: {
        filePath: 'https://www.weiqi888.com:5707/school_image/3/', //文件存储路径
        bookPath: 'https://www.weiqi888.com:5707/school_image/', //文件存储路径
        //dataPath: 'https://localhost:5707',
        dataPath: 'https://www.weiqi888.com:5707',
        fileName: '',
        ext: 'png', //'webp', //默认图片存储后缀为webp
        bigSize: false,
        longSize: true,
        system: 0, //0-表示安卓设备 1-表示苹果设备		
        isUpgrade: false, //表示是否需要升级系统
        selfImg: false, //自定义图片
        width: 0,
        height: 0,
        hwRote: 1,
        isShowChess: true
    },
    changeNameInfo: {
        isShow: false,
        title: '更改备注名',
        placeholder: '请输入备注名',
        text: '',
        key: 'bk_name',
        userId: '',
        page: null
    },
    addTiemInfo: {
        isShow: false,
        title: '增加时长'
    },
    changeWeiqiClassInfo: {
        isShow: false,
        title: '修改级别'
    },
    noticeInfo: {
        isShow: false,
        title: '通知',
        content: '',
        ending: ''
    },
    getDomain() {
        let host = window.location.host
        let port = window.location.port
        if (port == '8092') host = host.replace(port, '5707')
        if (!host.includes('5707')) host += ':5707'
        return `https://${host}`
    },
    init() {
        this.domain = this.getDomain();
        this.dataPath = this.domain

        this.ws = Ws.getWebSocket()
            /*let systemInfo = uni.getSystemInfoSync();
            console.log(systemInfo);
            this.sysInfo.width = systemInfo.screenWidth;
            this.sysInfo.height = systemInfo.screenHeight;
            this.sysInfo.bigSize = systemInfo.windowWidth > 500; //判断是否为平板显示设备
            this.sysInfo.hwRote = systemInfo.windowHeight / systemInfo.windowWidth;
            if (this.sysInfo.hwRote < 1.75) this.sysInfo.longSize = false;
            if (systemInfo.system.indexOf("iOS") != -1) {
            	this.sysInfo.system = 1;
            	this.sysInfo.ext = 'png';
            	let sysList = systemInfo.system.split(' ');
            	sysList = sysList[1];
            	let sysVersion = sysList.split('.')
            	sysVersion = parseInt(sysVersion[0]);
            	if (sysVersion < 10) this.sysInfo.isUpgrade = true;
            }
            this.checkUpdate();*/
    },
    setCurrPage(page) {
        this.currPage = page
    },
    checkUpdate() {

    },
    show(obj) {

    },
    share(isShare = true) {

    },
    getToday(year = 0) {
        var timestamp = Date.parse(new Date());
        var date = new Date(timestamp);
        //获取年份  
        var Y = date.getFullYear() + year;
        //获取月份  
        var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
        //获取当日日期 
        var D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
        //console.log("当前时间：" + Y + '年' + M + '月' + D + '日');
        return Y + '-' + M + '-' + D;
    },
    //格式化日期
    formatDate(date, fmt) {
        date = new Date(date);
        var o = {
            "y+": date.getFullYear(),
            "M+": date.getMonth() + 1,
            "d+": date.getDate(),
            "h+": date.getHours(),
            "m+": date.getMinutes(),
            "s+": date.getSeconds(),
            "q+": Math.floor((date.getMonth() + 3) / 3),
            "S": date.getMilliseconds()
        };
        if (/(y+)/.test(fmt)) {
            fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
        }
        for (var k in o) {
            if (new RegExp("(" + k + ")").test(fmt)) {
                fmt = fmt.replace(new RegExp("(" + k + ")"), (new RegExp("(" + k + ")").length == 1) ? (o[k]) : (("00" + o[k]).substr(
                    ("" + o[k]).length)));
            }
        }
        return fmt;
    },
    //得到今天的小时数
    getTodayHours() {
        let todayDate = new Date(); //获取系统当前时间
        return todayDate.getHours(); //获取当前小时数(0-23)
    },
    makeTanChuang(title = '', show = false, agree = function() {}, reject = function() {}) {
        return {
            title: title,
            show: show,
            agree: agree,
            reject: reject,
            btn_show: true
        }
    },
    createCanvasContext(id) {
        let c = document.getElementById(id);
        c.width = this.chess_board_size
        c.height = this.chess_board_size
        let ctx = c.getContext("2d");
        return ctx
    }
};


// WEBPACK FOOTER //
// ./src/common/global.js